// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// --- PEGA AQUÍ TU CONFIGURACIÓN DE GOOGLE ---
const firebaseConfig = {
  
  apiKey: "AIzaSyC2sBSaOAyDoX0p5-nJdHjnUaqU-lU95sQ",
  authDomain: "cardioagenda-5bd8b.firebaseapp.com",
  projectId: "cardioagenda-5bd8b",
  storageBucket: "cardioagenda-5bd8b.firebasestorage.app",
  messagingSenderId: "868885787022",
  appId: "1:868885787022:web:7f95687b23a616a7b874df"

};
// --------------------------------------------

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);